export default __webpack_public_path__ + "static/media/cloudy.24f9a474.svg";